import { Navigate, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Home from './routes/Home';
import Focus from './routes/Focus';
import Theme from './routes/Theme';
import Adhigaram from './routes/Adhigaram';
import Adhigarams from './routes/Adhigarams';
import About from './routes/About';
import Divergence from './routes/Divergence';
import './App.css';

export default function App() {
    return (
        <div className="app-root">
            <a className="skip-link" href="#main">
                Skip to content
            </a>
            <Header />
            <main id="main" className="app-main">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/kural/:n" element={<Focus />} />
                    <Route path="/theme/:slug" element={<Theme />} />
                    <Route path="/adhigaram/:slug" element={<Adhigaram />} />
                    <Route path="/adhigarams" element={<Adhigarams />} />
                    <Route path="/divergence" element={<Divergence />} />
                    <Route path="/about" element={<About />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </main>
        </div>
    );
}
